module.exports = __webpack_public_path__ + "static/media/a5.6061faaf.jpeg";